import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import OnlineDetails from './section-components/online-payment';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const OnlinePayment = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>PAY Direct | MIET Education Chennai</title>
            <meta name="description" content="MIET in Chennai offers top training and coaching for all levels of education. Provides customized syllabus and training for students. Call us to know more." />
        </Helmet>
        <PageHeader headertitle="Online Payment"  />
        <OnlineDetails />
        <Footer />
    </div>
}

export default OnlinePayment